import type { RouteObject } from "react-router-dom";
import SiteLayout from "../components/feature/SiteLayout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Hot from "../pages/hot/page";
import Article from "../pages/article/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "hot",
        element: <Hot />,
      },
      {
        path: "article/:id",
        element: <Article />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;